<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            ref="grid"
            :actions="actions"
            :beforeSetupGrid="beforeSetupGrid"
            :selectionEnabled="true"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            :onRowClicked="onRowClicked"
        ></dx-grid>

        <v-dialog persistent v-model="shareFileDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2"
                    >Share File</v-card-title
                >

                <v-layout row>
                    <v-btn
                        small
                        outline
                        class="mr-2"
                        :loading="uploading"
                        @click="pickFile()"
                    >
                        Upload Files
                        <v-icon right dark>mdi-cloud-upload</v-icon>
                    </v-btn>
                </v-layout>
                <div class="dropArea" ref="dropArea">
                    Drag and drop files here
                </div>
                <div v-if="files.length" class="pt-2 mt-0 ml-0">
                    <div
                        class="mt-2"
                        v-for="(file, index) in files"
                        :key="index"
                    >
                        {{ file.name }}
                        <!-- <v-btn icon small @click="removeFile(index)">
                            <v-icon small>mdi-close</v-icon>
                        </v-btn> -->
                    </div>
                </div>
                <input
                    type="file"
                    style="display: none"
                    ref="files"
                    @change="onFilePicked($event)"
                    multiple
                />

                <v-progress-linear
                    v-if="uploading"
                    :value="uploadProgress"
                    color="primary"
                    height="10"
                    class="mt-2"
                ></v-progress-linear>
                <div v-if="uploading" class="text-center mt-1">
                    {{ uploadProgress.toFixed(2) }}% ({{ uploadedBytes }} /
                    {{ totalBytes }} bytes)
                </div>

                <div class="text-danger mt-2" v-if="fileSizeError">
                    {{ fileSizeError }}
                </div>

                <div class="text-danger mt-2" v-if="fileTypeError">
                    {{ fileTypeError }}
                </div>

                <v-autocomplete
                    class="mt-3"
                    v-model="selectedUser"
                    :disabled="isUpdatingUser"
                    :items="users"
                    :search-input.sync="loadUsers"
                    chips
                    label="Users to Shared With"
                    item-text="userName"
                    item-value="userName"
                    multiple
                    ref="selectedUser"
                    hide-no-data
                    :rules="[rules.required]"
                >
                    <template v-slot:selection="data">
                        <v-chip
                            :selected="data.selected"
                            close
                            class="chip--select-multi"
                            @input="removeSelectedUser(data.item)"
                        >
                            {{ data.item }}
                        </v-chip>
                    </template>
                    <template v-slot:item="data">
                        <template>
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="data.item"
                                ></v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-autocomplete>

                <v-text-field
                    label="Instruction"
                    ref="instruction"
                    v-model="instruction"
                    :rules="[rules.maxMessageLength]"
                ></v-text-field>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="shareFileDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!files.length || uploading"
                        :loading="processing"
                        color="success"
                        @click="saveFile()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="deleteShareFilesDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Delete Shared Files</v-card-title
                >

                <div class="font-weight-medium">
                    The
                    {{ selected.length }}
                    selected files will be deleted
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="deleteShareFilesDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="deleteFiles()"
                    >
                        delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="updateFileDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-3"
                    >Update File Users</v-card-title
                >
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        File Name:
                    </div>
                    <div :title="rowClicked.fileName">
                        {{ truncateText(rowClicked.fileName, 33) }}
                    </div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Uploaded On:
                    </div>
                    <div>{{ rowClicked.uploadedOn | time }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Uploaded By:
                    </div>
                    <div>{{ rowClicked.uploadedBy }}</div>
                </v-layout>
                <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                        Expiration Date:
                    </div>
                    <div>{{ rowClicked.expirationDate | time }}</div>
                </v-layout>
                <v-layout row>
                    <div class="pt-3 subheading-1 font-weight-medium">
                        USERS
                    </div>
                    <v-btn
                        small
                        color="success"
                        class="ml-2"
                        @click="openAddUserDialog"
                        >Add User</v-btn
                    >
                    <v-divider
                        class="mt-4"
                        style="border-color: #42b966;"
                    ></v-divider>
                </v-layout>
                <div
                    v-for="(sharedFileUser,
                    index) in rowClicked.sharedFileUsers"
                >
                    <v-layout row>
                        <div class="pt-2">{{ sharedFileUser.user }}</div>

                        <v-btn
                            @click="openRemoveUserDialog(sharedFileUser)"
                            flat
                            icon
                            class="my-0"
                            color="success"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-layout>
                    <v-divider
                        v-if="index + 1 < rowClicked.sharedFileUsers.length"
                    ></v-divider>
                </div>
                <v-card-actions class="pb-0 mr-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="updateFileDialog = false"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="addUserDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2"
                    >Add User</v-card-title
                >

                <v-autocomplete
                    class=""
                    label="User to Shared With"
                    placeholder="Start typing..."
                    hide-no-data
                    clearable
                    ref="userToAdd"
                    v-model="rowClicked.userToAdd"
                    :items="usersToAdd"
                    :rules="[rules.required]"
                    :search-input.sync="loadUsersToAdd"
                ></v-autocomplete>

                <v-card-actions class="mr-0 mt-0 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="addUserDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="addUser()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="removeUserDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Remove User</v-card-title
                >

                <div>
                    User
                    <span class="font-weight-medium">{{
                        userToRemove.user
                    }}</span>
                    will be removed from having access to the file<br />
                    <span
                        class="font-weight-medium"
                        :title="rowClicked.fileName"
                        >{{ truncateText(rowClicked.fileName, 42) }}</span
                    >
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="removeUserDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="removeUser()"
                    >
                        remove
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { truncate, pluralize } from "../../utils/helpers.js";
import JSZip from "jszip";

export default {
    data: () => ({
        title: "Shared Files",

        actions: [],
        userBranch: "",
        url: "",
        regID: "",
        updateFileDialog: false,
        removeUserDialog: false,
        addUserDialog: false,
        userToRemove: {},
        processing: false,
        uploading: false,

        shareFileDialog: false,
        deleteShareFilesDialog: false,
        selectedUser: "",
        instruction: "",
        users: [],
        usersToAdd: [],
        isUpdatingUser: false,
        loadUsers: null,
        loadUsersToAdd: null,
        uploadUrls: [],
        files: [],
        selected: [],
        rowClicked: {},

        blockedFileTypes: [],

        fileSizeError: "",
        fileTypeError: "",

        uploadProgress: 0,
        uploadedBytes: 0,
        totalBytes: 0,
        uploadSessionId: null,

        rules: {
            required: (value) => !!value || "Required.",
            maxMessageLength: (value) => {
                return (
                    !value ||
                    value.length < 151 ||
                    "Only 150 characters are allowed"
                );
            },
        },

        columns: [
            {
                label: "File",
                field: "fileName",
                format: "",
                template: "link-action-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                showLink: (row) => {
                    return true;
                },
            },
            {
                label: "Uploaded On",
                field: "uploadedOn",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Uploaded By",
                field: "uploadedBy",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Expiration Date",
                field: "expirationDate",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Shared With",
                field: "sharedWith",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Instruction",
                field: "instruction",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    mounted() {
        this.setupDragAndDrop();
    },
    beforeDestroy() {
        this.removeDragAndDrop();
    },
    async created() {
        this.columns.find((c) => c.field == "fileName").linkAction = (row) => {
            if (row.url == "DELETED") return;

            this.downloadFile(row);
            //window.open(row.url);
        };

        this.loadBlockedFileTypes();
        this.loadUserList();

        if (this.$route.query.shareNewFile) {
            this.openShareFileDialog();
        }
    },
    watch: {
        async loadUsers(value) {
            //if (!value) return;

            const response = await this.$http.get(
                `/odata/users?$count=true&$filter=(contains(userName, '${
                    value ? value.trim() : ""
                }'))` + (!value ? "&$orderby=userName asc" : ""),
            );

            this.users = response.value.map((u) => u.userName);

            // if (value && this.$refs.selectedUser) {
            //     this.$refs.selectedUser.focus();
            //     this.$refs.selectedUser.activateMenu();
            // }
        },
        async loadUsersToAdd(value) {
            //if (!value) return;

            const response = await this.$http.get(
                `/odata/users?$count=true&$filter=(contains(userName, '${
                    value ? value.trim() : ""
                }'))` + (!value ? "&$orderby=userName asc" : ""),
            );

            this.usersToAdd = response.value.map((u) => u.userName);
        },
    },
    methods: {
        async loadUserList() {
            const response = await this.$http.get(
                `/odata/users?$count=true&$orderby=userName asc`,
            );

            this.users = response.value.map((u) => u.userName);
        },
        async downloadFile(file) {
            try {
                const response = await fetch(file.url);
                if (!response.ok)
                    throw new Error("Network response was not ok");

                const blob = await response.blob();
                const link = document.createElement("a");
                const blobUrl = window.URL.createObjectURL(blob);

                link.href = blobUrl;
                link.download = file.fileName; // Default filename if none provided
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Download failed:", error);
            }
        },
        setupDragAndDrop() {
            const dropArea = this.$refs.dropArea;

            ["dragenter", "dragover", "dragleave", "drop"].forEach(
                (eventName) => {
                    dropArea.addEventListener(
                        eventName,
                        this.preventDefaults,
                        false,
                    );
                },
            );

            ["dragenter", "dragover"].forEach((eventName) => {
                dropArea.addEventListener(eventName, this.highlight, false);
            });

            ["dragleave", "drop"].forEach((eventName) => {
                dropArea.addEventListener(eventName, this.unhighlight, false);
            });

            ["click"].forEach((eventName) => {
                dropArea.addEventListener(eventName, this.pickFile, false);
            });

            dropArea.addEventListener("drop", this.handleDrop, false);
        },
        removeDragAndDrop() {
            const dropArea = this.$refs.dropArea;

            ["dragenter", "dragover", "dragleave", "drop"].forEach(
                (eventName) => {
                    dropArea.removeEventListener(
                        eventName,
                        this.preventDefaults,
                        false,
                    );
                },
            );

            ["dragenter", "dragover"].forEach((eventName) => {
                dropArea.removeEventListener(eventName, this.highlight, false);
            });

            ["dragleave", "drop"].forEach((eventName) => {
                dropArea.removeEventListener(
                    eventName,
                    this.unhighlight,
                    false,
                );
            });

            ["click"].forEach((eventName) => {
                dropArea.removeEventListener(eventName, this.pickFile, false);
            });

            dropArea.removeEventListener("drop", this.handleDrop, false);
        },
        preventDefaults(e) {
            e.preventDefault();
            e.stopPropagation();
        },
        highlight(e) {
            e.target.classList.add("highlight");
        },
        unhighlight(e, dropArea) {
            e.target.classList.remove("highlight");
        },
        handleDrop(e) {
            const files = Array.from(e.dataTransfer.files);

            if (!files) return;

            this.uploadFiles(files);
        },
        async onRowClicked(row) {
            this.rowClicked = row;

            const response = await this.$http.get(
                "api/sharedFiles/getUsersForFile?id=" + this.rowClicked.id,
            );

            this.rowClicked.sharedFileUsers = response;

            this.updateFileDialog = true;
        },
        async beforeSetupGrid() {
            if (this.isAdmin()) {
                this.actions.push({
                    text: "Filter for " + this.$store.state.authentication.user,
                    type: "switch",
                    align: "left",
                    action: this.onUserFilterChanged,
                });
            }

            this.actions.push({
                text: "Delete",
                action: this.openDeleteDialog,
                showOnSelection: true,
            });

            this.actions.push({
                text: "Share File",
                action: this.openShareFileDialog,
            });

            this.url =
                "sharedFiles?user=" +
                (this.getUser() ? "" + this.getUser() : "");
        },
        onUserFilterChanged(value) {
            if (value) {
                this.url =
                    "sharedFiles?user=" + this.$store.state.authentication.user;
            } else {
                this.url = "sharedFiles?user=";
            }

            this.$refs.grid.reloadDataSource(this.url);
        },
        async loadBlockedFileTypes() {
            this.blockedFileTypes = await this.$http.get(
                "api/sharedFiles/getBlockedFileTypes",
            );
        },
        openRemoveUserDialog(user) {
            this.userToRemove = user;
            this.removeUserDialog = true;
        },
        openShareFileDialog() {
            this.uploadUrl = "";
            this.selectedUser = "";
            this.instruction = "";

            this.shareFileDialog = true;

            if (this.$refs.instruction) {
                this.$refs.instruction.resetValidation();
            }
        },
        getUser() {
            if (this.isAdmin()) return null;

            return this.$store.state.authentication.user;
        },
        isAdmin() {
            const isAdmin = this.$store.getters["authentication/isAdmin"];

            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        removeSelectedUser(item) {
            const index = this.selectedUser.indexOf(item);
            if (index >= 0) this.selectedUser.splice(index, 1);
        },
        openImportDialog() {
            this.importDialog = true;
        },
        async openDeleteDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();

            this.deleteShareFilesDialog = true;
        },
        async deleteFiles() {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/sharedFiles/DeleteFiles",
                    this.selected.map((s) => s.id),
                );

                this.processing = false;
                this.deleteShareFilesDialog = false;

                this.$refs.grid.reloadGrid();

                this.$notify({
                    group: "notification",
                    text: "Files Deleted",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
        truncateText(text, count = 25) {
            return truncate(text, count);
        },
        pickFile() {
            this.$refs.files.click();
        },
        async onFilePicked(e, isNew = false) {
            const files = Array.from(e.target.files);

            if (!files.length) return;

            this.uploadFiles(files);
        },
        async uploadFiles(files) {
            this.files = [];
            this.fileSizeError = "";
            this.fileTypeError = "";
            this.uploadProgress = 0;
            this.uploadedBytes = 0;
            this.totalBytes = files.reduce((sum, file) => sum + file.size, 0);
            this.uploadUrls = [];

            const compressedExtensions = ["zip", "rar", "7z", "tar", "gz"];
            const typeList = this.blockedFileTypes.map((f) => f.type);

            // Validate all files first
            for (const file of files) {
                const fileSize = file.size / 1024 / 1024;
                if (fileSize > 500) {
                    this.fileSizeError = `File ${
                        file.name
                    } exceeds the maximum limit of 500 MB`;
                    return;
                }

                const fileType = file.type.split("/")[1];
                const fileExtension = file.name
                    .split(".")
                    .pop()
                    .toLowerCase();

                if (
                    typeList.includes(fileType) ||
                    typeList.includes(fileExtension)
                ) {
                    this.fileTypeError = `File type not allowed for ${
                        file.name
                    }`;
                    return;
                }

                const isCompressedFile = compressedExtensions.includes(
                    fileExtension,
                );
                if (isCompressedFile && fileExtension === "zip") {
                    const zip = await JSZip.loadAsync(file);
                    const hasBlockedTypes = Object.keys(zip.files).some((key) =>
                        typeList.includes(key.split(".").pop()),
                    );
                    if (hasBlockedTypes) {
                        this.fileTypeError = `The ZIP file ${
                            file.name
                        } contains a restricted file type`;
                        return;
                    }
                } else if (isCompressedFile) {
                    this.fileTypeError = `File type not allowed for ${
                        file.name
                    }`;
                    return;
                }
            }

            // Add valid files to the list
            this.files = files;

            try {
                for (const file of files) {
                    await this.uploadFileInChunks(file);
                }

                this.uploading = false;
            } catch (e) {
                this.uploading = false;
                this.fileSizeError = "Upload failed. Please try again.";
                console.error(e);
            }
        },
        async uploadFileInChunks(file) {
            const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB chunks
            const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
            const uploadSessionId = `${Date.now()}_${Math.random()
                .toString(36)
                .substr(2, 9)}`;

            this.uploading = true;

            try {
                for (
                    let chunkIndex = 0;
                    chunkIndex < totalChunks;
                    chunkIndex++
                ) {
                    const start = chunkIndex * CHUNK_SIZE;
                    const end = Math.min(start + CHUNK_SIZE, file.size);
                    const chunk = file.slice(start, end);

                    const formData = new FormData();
                    formData.append("chunk", chunk);
                    formData.append("sessionId", uploadSessionId);
                    formData.append("chunkIndex", chunkIndex);
                    formData.append("totalChunks", totalChunks);
                    formData.append("fileName", file.name);

                    await this.$http.post(
                        "api/adminportal/uploadChunk",
                        formData,
                        {
                            headers: { "Content-Type": "multipart/form-data" },
                            onUploadProgress: (progressEvent) => {
                                this.uploadedBytes += progressEvent.loaded;
                                this.uploadProgress =
                                    (this.uploadedBytes / this.totalBytes) *
                                    100;
                            },
                        },
                    );
                }

                const response = await this.$http.post(
                    "api/adminportal/finalizeUpload",
                    {
                        sessionId: uploadSessionId,
                        fileName: file.name,
                    },
                );

                this.uploadUrls.push(response.url);
            } catch (e) {
                throw e;
            }
        },
        async saveFile() {
            if (!this.$refs.instruction.validate(true)) return;

            if (!this.selectedUser.length) {
                return this.$notify({
                    group: "notification",
                    text:
                        "Oops! It looks like no users have been selected yet. Please choose at least one user to share with.",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                const response = await this.$http.post("api/sharedFiles/save", {
                    files: this.uploadUrls.map((url) => ({
                        uploadedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
                        url: url,
                        uploadedBy: this.$store.state.authentication.user,
                        instruction: this.instruction,
                    })),
                    users: this.selectedUser,
                });

                this.processing = false;
                this.$refs.files.value = "";
                this.files = [];
                this.shareFileDialog = false;
                this.$refs.grid.reloadGrid();
                this.$refs.selectedUser.resetValidation();
            } catch (e) {
                console.log(e);
                this.processing = false;
            }
        },
        openAddUserDialog() {
            this.rowClicked.userToAdd = "";
            this.addUserDialog = true;
            this.$refs.userToAdd.resetValidation();
        },
        async addUser() {
            if (!this.$refs.userToAdd.validate(true)) return;

            if (!this.rowClicked.userToAdd) {
                return this.$notify({
                    group: "notification",
                    text: "Please select a user to add.",
                    type: "error",
                });
            }

            if (
                this.rowClicked.sharedFileUsers.some(
                    (u) => u.user == this.rowClicked.userToAdd,
                )
            ) {
                return this.$notify({
                    group: "notification",
                    text: "User already added",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/sharedFiles/addUser", {
                    sharedFileID: this.rowClicked.id,
                    user: this.rowClicked.userToAdd,
                });

                this.processing = false;
                this.addUserDialog = false;

                this.$notify({
                    group: "notification",
                    text: "User added",
                    type: "success",
                });

                const response = await this.$http.get(
                    "api/sharedFiles/getUsersForFile?id=" + this.rowClicked.id,
                );

                this.rowClicked.sharedFileUsers = response;

                this.$forceUpdate();
                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
        async removeUser() {
            try {
                this.processing = true;

                const user = this.rowClicked.sharedFileUsers.find(
                    (s) => s.user == this.userToRemove.user,
                );

                await this.$http.post(
                    "api/sharedFiles/RemoveUser?id=" + user.id,
                );

                this.processing = false;
                this.removeUserDialog = false;

                this.$notify({
                    group: "notification",
                    text: "User removed",
                    type: "success",
                });

                const response = await this.$http.get(
                    "api/sharedFiles/getUsersForFile?id=" + this.rowClicked.id,
                );

                this.rowClicked.sharedFileUsers = response;

                this.$forceUpdate();
                this.$refs.grid.reloadGrid();
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
[v-cloak] {
    display: none;
}
.v-btn__content {
    color: unset;
}
.accounts-search.container {
    padding-top: 0px;
}
.yg-student-account-match {
    border: 2px solid #4caf50;
}
.dropArea {
    border: 2px dashed #ccc;
    width: 100%;
    height: 150px;
    text-align: center;
    padding: 20px;
    cursor: pointer;
}
.highlight {
    border-color: #fc0;
}
</style>
